import AxiosAPI from '../../utils/AxiosAPI';

// operation for update user new photo
export const handleUpdateProfilePhotoOpe = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api2/self-modify/change-profile-image`)
            .put(formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// Purchase Create Invoice
export const handleSaveUserInfo = (type, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api2/self-modify/change-${type}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// operation for update address
export const handleUpdateAddressOpe = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api2/self-modify/change-address`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

export default null;
